var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ttl-editor" }, [
    _c(
      "h4",
      { staticStyle: { "margin-bottom": "8px" } },
      [
        _c("a-icon", {
          staticStyle: { "margin-right": "8px" },
          attrs: { type: "clock-circle" },
        }),
        _vm._v("\n        Message Time-to-Live (TTL) • Optional\n    "),
      ],
      1
    ),
    _vm._v(" "),
    _c("p", { staticClass: "ttl-description" }, [
      _vm._v("\n        " + _vm._s(_vm.getTtlDescription) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ttl-input-row" },
      [
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: {
              value: _vm.value,
              placeholder: "Select TTL or leave default",
              allowClear: "",
            },
            on: { change: _vm.handleChange },
          },
          _vm._l(_vm.getTtlOptions, function (option) {
            return _c(
              "a-select-option",
              { key: option.value, attrs: { value: option.value } },
              [
                _vm._v(
                  "\n                " + _vm._s(option.label) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ttl-info" },
      [
        _c("a-icon", {
          staticStyle: { "margin-right": "4px", color: "#1890ff" },
          attrs: { type: "info-circle" },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.getTtlInfoText))]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }